module.exports = __webpack_public_path__ + "img/6.ee1e5903.png";